module.exports = __webpack_public_path__ + "static/media/globo.b9bc2e6d.png";